import { useEffect, useState } from "react";
import { useStyle } from "./style";
import { IBusinessWidget } from "@/interfaces";
import { UpdateValueAutoComplete } from "@/components";
import { adaptMarginRight } from "@/utils/adapter";
import { useTranslation } from "react-i18next";

const AutoCompleteUpdatedValue = ({
  label,
  value,
  isUnderLine,
  onBlur,
  isUpdate,
  setIsUpdate,
  options,
  getOptionLabel,
  onChange,
  onChangeTextField,
  isFetching,
  defaultFiltering,
  renderOption,
  showClearIcon = false,
  filterOptions,
  className,
  selectValue = false,
}: IBusinessWidget & { selectValue?: boolean }) => {
  const { classes, isMobile } = useStyle({ isUnderLine });
  const [updateValue, setUpdateValue] = useState();
  const { t } = useTranslation();
  const dir = t("direction");

  useEffect(() => {
    setUpdateValue(value);
  }, [value]);

  const valueContent = isUpdate ? (
    <UpdateValueAutoComplete
      clickedOut={() => onBlur()}
      onCancel={() => setIsUpdate(null)}
      onUpdate={() => onBlur()?.then()}
      value={updateValue}
      options={options}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      onChangeTextField={onChangeTextField}
      selectValue={selectValue}
      loading={isFetching}
      defaultFiltering={defaultFiltering}
      renderOption={renderOption}
      filterOptions={filterOptions}
    />
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        ...(isMobile ? { flex: 1, minWidth: 0 } : {}),
      }}
    >
      <div
        style={classes.inputTextStyle}
        className="customInput"
        onClick={() => setIsUpdate(1)}
      >
        {value}
      </div>
      {showClearIcon && (
        <div
          onClick={() => {
            onChange(null, null);
            setUpdateValue(null);
          }}
          style={{
            ...adaptMarginRight(dir, 8),
            cursor: "pointer",
            fontWeight: "bold",
            color: "#888",
            fontSize: "14px",
            ...(isMobile ? { flexShrink: 0 } : {}),
          }}
        >
          &#10005;
        </div>
      )}
    </div>
  );

  return (
    <>
      <div
        style={classes.inputMainContainer}
        className={
          className ? `gm-field gm-field-row ${className}` : "gm-field gm-field-row"
        }
      >
        <div style={classes.labelStyle} className="gm-field-label">
          {label}
        </div>
        {isMobile ? (
          <div style={classes.valueWrapper}>{valueContent}</div>
        ) : (
          valueContent
        )}
      </div>
    </>
  );
};

export { AutoCompleteUpdatedValue };
